export const FontFamily = {
  Normal: "Inter",
  SemiBold: "Inter",
  Bold: "Inter",
  Regular: "Inter",
  Black: "Inter",
  BlackItalic: "Inter",
  BoldItalic: "Inter",
  ExtraBold: "Inter",
  ExtraBoldItalic: "Inter",
  ExtraLight: "Inter",
  ExtraLightItalic: "Inter",
  Italic: "Inter",
  Medium: "Inter",
  Thin: "Inter",
  Light: "Inter",
  LightItalic: "Inter",
  SemiBoldItalic: "Inter",
  PoppinsNormal: "Poppins",

  // Normal:"Inter",
  // SemiBold: "Inter-SemiBold",
  // Bold: "Inter-Bold",
  // Regular: "Inter-Regular",
  // Black: "Inter-Black",
  // BlackItalic: "Inter-BlackItalic",
  // BoldItalic: "Inter-BoldItalic",
  // ExtraBold: "Inter-ExtraBold",
  // ExtraBoldItalic: "Inter-ExtraBoldItalic",
  // ExtraLight: "Inter-ExtraLight",
  // ExtraLightItalic: "Inter-ExtraLightItalic",
  // Italic: "Inter-Italic",
  // Medium:'Inter-Medium',
  // Thin:'Inter-Thin',
  // Light: "Inter-Light",
  // LightItalic: "Inter-LightItalic",
  // SemiBoldItalic: "Inter-SemiBoldItalic",
};

export const FontSize = {
  h0: 56,
  h1: 48,
  h2: 32,
  title5: 40,
  title: 24,
  title1: 22,
  title2: 27,
  h3: 20,
  h4: 18,
  h5: 16,
  p1: 15,
  p2: 14,
  p3: 12,
  p4: 13,
  small: 10,
  eleven: 11,
  nine: 9,
  eight: 8,
  seven: 7,
  six: 6,
  five: 5,
  title3: 36,
  title6: 45,
  title4: 28,
  title7: 26,
};
